// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".leftStyle[data-v-7949fbf1] {\n  position: absolute;\n  left: -200px;\n  top: 1px;\n  font-size: 12px;\n}\n#appStyle[data-v-7949fbf1] {\n  position: relative;\n  top: 0px;\n  left: 320px;\n  width: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
